export const AUTOTEST_SERVICE_ENDPOINT = window.env.VUE_APP_AUTOTEST_SERVICE_DOMAIN;

// Resource paths
export const MODULE_TEST_PATH = '/module-test';
